import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import AkErrorIcon from '@atlaskit/icon/glyph/error';
import { G300, R400 } from '@atlaskit/theme/colors';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const getFlagForInternetIssue = () => {
  return {
    id: 'internet-offline-flag',
    description: ' It looks like you’re not connected to internet. Check your network connection and try again.',
    icon: /*#__PURE__*/_jsx(AkErrorIcon, {
      size: "medium",
      primaryColor: R400
    }),
    title: 'Your internet may be off.',
    isAutoDismiss: true
  };
};
export const getFlagForSuccess = function getFlagForSuccess(id, title) {
  let description = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  let isAutoDismiss = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return {
    id,
    title,
    description,
    isAutoDismiss,
    icon: /*#__PURE__*/_jsx(SuccessIcon, {
      size: "medium",
      primaryColor: G300
    })
  };
};
export const getFlagForError = function getFlagForError(id, title, description) {
  let isAutoDismiss = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (!navigator.onLine) {
    return getFlagForInternetIssue();
  }
  return {
    id,
    description: description !== null && description !== void 0 ? description : 'It might just be a hiccup. Try again in a bit.',
    icon: /*#__PURE__*/_jsx(AkErrorIcon, {
      size: "medium",
      primaryColor: R400
    }),
    title,
    isAutoDismiss
  };
};